// Move items
const items = document.querySelectorAll('.resource-item .item');

items.forEach((item) => {
  const resourceSection = item.previousElementSibling;
  const resourceSectionContent = resourceSection.querySelector('.content');

  if (resourceSection.classList.contains('resource-section')) {
    resourceSectionContent.appendChild(item);
  }
});

// Accordion logic
const resourceItems = document.querySelectorAll('.resource-item');

resourceItems.forEach((item) => {
  const heading = item.querySelector('.title');
  const resourceContent = item.querySelector('.resource-content');
  var contentHeight = resourceContent.scrollHeight;

  heading.addEventListener('click', () => {
    console.log(item);
    if (item.classList.contains('is--open')) {
      item.classList.remove('is--open');
      resourceContent.style.height = '0px';
    } else {
      item.classList.add('is--open');
      resourceContent.style.height = contentHeight + 'px';
    }
  });
});
